import React from "react";
import { useTranslation } from "react-i18next";

export default function LegalPage({ ns, sections }) {
  const { t } = useTranslation();
  return (
    <section className="bg-[#F7F3EA]">
      <div className="mx-auto max-w-3xl px-5 py-14 md:py-20">
        <p className="text-[12px] font-semibold uppercase tracking-wider text-[#B3862B]">Mirexiluna</p>
        <h1 className="mt-3 text-[32px] md:text-[42px] font-semibold tracking-tight text-[#0F1B2D] leading-tight">
          {t(`${ns}.title`)}
        </h1>
        <p className="mt-2 text-[13px] text-[#4b5563]">{t(`${ns}.updated`)}</p>

        <div className="mt-10 space-y-8">
          {sections.map((k) => (
            <div key={k}>
              <h2 className="text-[18px] font-semibold text-[#0F1B2D]">{t(`${ns}.${k}Title`)}</h2>
              <p className="mt-2 text-[15px] leading-relaxed text-[#374151]">{t(`${ns}.${k}Body`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
